import React from 'react'

const Error = () => {
  return (
    <div className='flex justify-center items-center h-screen text-3xl text-white align-center'>
      Error - 404 Not found
    </div>
  )
}

export default Error
